export default __webpack_public_path__ + "static/media/user_icon_primary.d29eb831.svg";